export default "__VITE_ASSET__Do93fV$r__"